(function () {
  if (window.ourMetodologyComponentLoaded) return;
  window.ourMetodologyComponentLoaded = true;

  const SECTION_SELECTOR = '[data-our-metodology-section]';
  const CONFIG_SELECTOR = '[data-our-metodology-config]';
  const SWIPER_SELECTOR = '[data-our-metodology-swiper]';
  const PAGINATION_SELECTOR = '[data-our-metodology-pagination]';

  const DEFAULT_CONFIG = {
    slidesPerViewMobile: 1.3,
    slidesPerViewTablet: 2.3,
    slidesPerViewDesktop: 3,
    spaceBetweenMobile: 15,
    spaceBetweenDesktop: 30,
    showPagination: true
  };

  function parseConfig(section) {
    const configElement = section.querySelector(CONFIG_SELECTOR);
    if (!configElement) return Object.assign({}, DEFAULT_CONFIG);

    try {
      return Object.assign({}, DEFAULT_CONFIG, JSON.parse(configElement.textContent || '{}'));
    } catch (error) {
      return Object.assign({}, DEFAULT_CONFIG);
    }
  }

  function getYoutubeEmbedUrl(url) {
    let videoId = '';

    if (url.includes('youtu.be/')) {
      videoId = url.split('youtu.be/')[1].split('?')[0];
    } else if (url.includes('youtube.com')) {
      const query = url.split('v=')[1];
      videoId = query ? query.split('&')[0] : '';
    }

    return videoId ? 'https://www.youtube.com/embed/' + videoId + '?autoplay=1' : '';
  }

  function getVimeoEmbedUrl(url) {
    if (!url.includes('vimeo.com/')) return '';

    const videoId = url.split('vimeo.com/')[1].split('?')[0];
    return videoId ? 'https://player.vimeo.com/video/' + videoId + '?autoplay=1' : '';
  }

  function getVideoEmbedUrl(url) {
    if (!url) return '';
    if (url.includes('youtube.com') || url.includes('youtu.be')) return getYoutubeEmbedUrl(url);
    if (url.includes('vimeo.com')) return getVimeoEmbedUrl(url);
    return '';
  }

  function bindVideo(section) {
    const videoButton = section.querySelector('.video-play-button');
    if (!videoButton || videoButton.dataset.ourMetodologyVideoBound === 'true') return;

    videoButton.dataset.ourMetodologyVideoBound = 'true';
    videoButton.addEventListener('click', function () {
      const embedUrl = getVideoEmbedUrl(this.getAttribute('data-video-url') || '');
      const videoContainer = this.closest('.video-container');
      const iframeContainer = videoContainer ? videoContainer.querySelector('.video-iframe-container') : null;
      const thumbnail = videoContainer ? videoContainer.querySelector('.video-thumbnail') : null;

      if (!embedUrl || !iframeContainer) return;

      const iframe = document.createElement('iframe');
      iframe.setAttribute('src', embedUrl);
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
      iframe.setAttribute('allowfullscreen', '');
      iframe.style.borderRadius = '0';
      iframe.style.setProperty('border-radius', '0', 'important');

      iframeContainer.style.borderRadius = '0';
      iframeContainer.style.setProperty('border-radius', '0', 'important');
      iframeContainer.replaceChildren(iframe);
      iframeContainer.style.display = 'block';

      if (thumbnail) thumbnail.style.display = 'none';
      this.style.display = 'none';
    });
  }

  function initSwiper(section, config) {
    const sliderEl = section.querySelector(SWIPER_SELECTOR);
    if (!sliderEl) return;

    if (typeof window.Swiper === 'undefined') {
      window.setTimeout(function () {
        initSwiper(section, config);
      }, 80);
      return;
    }

    if (sliderEl.swiper) {
      sliderEl.swiper.destroy(true, true);
    }

    const paginationEl = section.querySelector(PAGINATION_SELECTOR);
    const swiperConfig = {
      slidesPerView: config.slidesPerViewMobile,
      spaceBetween: config.spaceBetweenMobile,
      centeredSlides: true,
      initialSlide: 0,
      loop: false,
      allowTouchMove: true,
      simulateTouch: true,
      speed: 600,
      observer: true,
      observeParents: true,
      breakpoints: {
        768: {
          slidesPerView: config.slidesPerViewTablet,
          spaceBetween: config.spaceBetweenMobile
        },
        1024: {
          centeredSlides: false,
          slidesPerView: config.slidesPerViewDesktop,
          spaceBetween: config.spaceBetweenDesktop
        }
      }
    };

    if (config.showPagination && paginationEl) {
      swiperConfig.pagination = {
        el: paginationEl,
        clickable: true
      };
    }

    new window.Swiper(sliderEl, swiperConfig);
  }

  function initSection(section) {
    if (!section || section.dataset.ourMetodologyInitialized === 'true') return;

    section.dataset.ourMetodologyInitialized = 'true';
    const config = parseConfig(section);

    bindVideo(section);
    initSwiper(section, config);
  }

  function initAll(root) {
    const scope = root || document;
    if (scope.matches && scope.matches(SECTION_SELECTOR)) {
      initSection(scope);
    }
    scope.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
